module.exports = __webpack_public_path__ + "img/lunbo1.32d28a15.png";